import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';
import { useSidebar } from '@/contexts/SidebarContext';

const AppLayout: React.FC = () => {
    const { toggleSidebar } = useSidebar();

    return (
        <div className="flex h-screen bg-[#000000] overflow-hidden text-white font-grotesk selection:bg-[#02DFC2]/30">


            {/* Premium Glass Sidebar */}
            <Sidebar />

            <div className="flex-1 flex flex-col relative z-10 overflow-hidden h-screen min-w-0">
                {/* Mobile Header (Hidden on Desktop) */}
                <header className="lg:hidden h-16 border-b border-slate-800/60 bg-black/60 backdrop-blur-xl flex items-center px-4 justify-between sticky top-0 z-20 shadow-lg">
                    <div className="flex items-center gap-3">
                        <button
                            onClick={toggleSidebar}
                            className="p-2 -ml-2 text-slate-400 hover:text-white transition-colors rounded-lg hover:bg-slate-800/50"
                        >
                            <Menu className="h-6 w-6" />
                        </button>
                        <div className="flex items-center gap-2">
                            <div className="w-1.5 h-4 bg-gradient-to-b from-[#52CB9E] to-[#02DFC2] rounded-full" />
                            <span className="font-bold text-white tracking-wide">ThreatInformant</span>
                        </div>
                    </div>
                </header>

                {/* Main Scrollable Content */}
                <main className="flex-1 overflow-y-auto custom-scrollbar relative pb-10">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AppLayout;